<template>
	<Card :dis-hover="true">
		<Tabs v-model="pageType" :animated="false" :capture-focus="true">
			<TabPane label="总监" name="inspector">
				<RoleDeptInspectorList v-if="pageType === 'inspector'" />
			</TabPane>
			<TabPane label="客户经理项目人" name="cusMgrLeader">
				<RoleDeptCusMgrLeaderList v-if="pageType === 'cusMgrLeader'" />
			</TabPane>
		</Tabs>
	</Card>
</template>

<script>
import RoleDeptInspectorList from './../../system-management/project-management/role-dept-inspector-list';
import RoleDeptCusMgrLeaderList from './../../system-management/project-management/role-dept-cusMgrLeader-list';

export default {
    name: 'RoleDeptListPage',
    components: {
        RoleDeptInspectorList,
        RoleDeptCusMgrLeaderList
    },
    data() {
        return {
            pageType: "inspector"
        };
    },
    mounted() {},
    methods: {}
};
</script>

<style scoped>
</style>
